<template>
  <section v-if="!pending" class="related">
    <LazyBlogArticlePreview
      v-for="article in relatedPosts"
      :key="article.uuid"
      :hide-author="true"
      :article="article"
    />
  </section>
</template>

<script lang="ts" setup>
const storyblokApi = useStoryblokApi()

interface Props {
  categories: any
  uid?: string
}
const props = defineProps<Props>()

const relatedPostsQueryParams = {
  starts_with: 'blog/articles',
  per_page: 3,
  sort_by: 'first_published_at:desc',
  filter_query: {
    categories: {
      in_array: props?.categories?.[0]?.uuid,
    },
    _uid: {
      not_in: props?.uid,
    },
  },
}

const { pending, data: relatedPosts } = await useLazyAsyncData(
  'articles-related',
  async () => await storyblokApi.get('cdn/stories', relatedPostsQueryParams),
  { transform: (data) => data.data.stories },
)
</script>

<style lang="scss" scoped>
.related {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 40px;
  row-gap: 48px;

  @media (min-width: $breakpoint-md) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: $breakpoint-lg) {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
